






































































































































import MemoryStack from './MemoryStack.vue';
import DataOutput from './DataOutput.vue';
import Vue, {PropType} from 'vue';

export default Vue.extend({
    name: 'memory-debugger',

    components: { DataOutput, MemoryStack },

    data: (): { componentKey: number } => ({ componentKey: 0 }),

    props: {
        totalBlocks: {
            type: Number,
            required: true,
        },
        currentBlock: {
            type: Number,
            required: true,
        },
        memory: {
            type: Array as PropType<number[]>,
            required: true,
            // validator: (m) => m.length === 256,
        },
        stackData: Array,
        lastUpdated: { type: Array as PropType<number[]>, default: (): number[] => [] },
    },
    methods: {
        changeMemoryBlock(n: number) {
            if (this.currentBlock + n < 0 || this.currentBlock + n >= this.totalBlocks)
                return;
            this.$emit('change-memory-block', this.currentBlock + n);
        },
        dataTooltip(pos: number): string {
            const data = this.memory[pos] || 0;
            return `Decimal: ${data}, Binary: 0b${data.toString(2).padStart(8, '0')}`;
        },
        blockInputChanged(value: number) {
            if (value >= 0 && value < this.totalBlocks)
                this.$emit('change-memory-block', value);
            else
                ++this.componentKey;
        },
        blockInputClicked() {
            const newValue = window.prompt('Please choose a hexadecimal value for the memory block (ex.: "F0"):');
            if (newValue !== null) {
                const newNumber = parseInt(newValue, 16);
                if (isNaN(newNumber))
                    window.alert('Not a valid memory position.');
                else if (newNumber < 0 || newNumber > this.totalBlocks)
                    window.alert(`The new memory block must be a hexadecimal number between 0 and ${this.totalBlocks}.`);
                else
                    this.$emit('change-memory-block', newNumber);
            }
        },
    },
});
